import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import { S3Client, PutObjectCommand } from '@aws-sdk/client-s3';
import axios from 'axios';
import { APIURL } from '../../../Global';

const handleSubmit = async (info, elementRef, type, alert, total) => {

    try {
        // Generate PDF
        const canvas = await html2canvas(elementRef.current, {
            scale: 1.2,
            useCORS: true,
            allowTaint: true,
            backgroundColor: '#ffffff'
        });

        const imgData = canvas.toDataURL('image/jpeg', 0.7);
        const pdf = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });

        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();
        const imgWidth = canvas.width;
        const imgHeight = canvas.height;
        const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);
        const imgX = (pdfWidth - imgWidth * ratio) / 2;
        const imgY = (pdfHeight - imgHeight * ratio) / 2;

        pdf.addImage(imgData, 'JPEG', imgX, imgY, imgWidth * ratio, imgHeight * ratio);
        const pdfBuffer = pdf.output('arraybuffer');

        // Upload to S3
        const s3Client = new S3Client({
            region: 'ap-southeast-1',
            credentials: {
                accessKeyId: "Y0WWU13PSR9JMDUASN8V",
                secretAccessKey: "DF7tATk9SPB0aGkf8tzXkYcfHaBhl2BQzp3hRcm1",
            },
            endpoint: "https://s3.ap-southeast-1.wasabisys.com",
            forcePathStyle: true,
        });

        const timestamp = new Date().toISOString().split('.')[0].replace(/[:T]/g, '-');
        const fileName = `${info?.id || 'unknown'}_${timestamp}.pdf`;
        const filePath = `Peace Village/patient/${info.id}/assessment_score/${type}/${fileName}`;

        const params = {
            Bucket: 'pvdev',
            Key: `${filePath}`,
            Body: new Uint8Array(pdfBuffer),
            ContentType: 'application/pdf',
        };

        // Add timeout wrapper
        const timeout = (ms) => new Promise((_, reject) => setTimeout(() => reject(new Error('Upload timed out')), ms));
        await Promise.race([
            s3Client.send(new PutObjectCommand(params)),
            timeout(15000)
        ]);

        const fileUrl = `https://s3.ap-southeast-1.wasabisys.com/pvdev/${filePath}`;

        const document = {
            title: fileName,
            file_name: filePath,
            file_type: type,
            file_url: fileUrl
        };

        const payload = {
            patient: +info.id,
            recording_scale: 'score',
            score_scale: type,
            assessment_type: 'neuro',
            therapy_consultation: info.therapy_consultation,
            total_score: total,
            scale_document: JSON.stringify(document)
        };

        const tokenString = sessionStorage.getItem('usertoken');
        const token = tokenString?.replace(/["]+/g, '');

        const therapyScaleResponse = await axios.post(`${APIURL}/api/v1/patient/therapy-scale/`, payload, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Token ${token}`
            }
        });

        // Check API response status
        if (therapyScaleResponse.data && therapyScaleResponse.data.status === 'error') {
            throw new Error(therapyScaleResponse.data.message || 'API returned error status');
        }

        alert.success('Saved successfully');
        return {
            success: true,
            fileName,
            bucket: "pvdev",
            fileUrl,
            therapyScaleResult: therapyScaleResponse.data
        };

    } catch (error) {
        // Enhanced error handling
        let errorMessage = 'Error saving assessment';

        if (error.response) {
            // API error response
            errorMessage = error.response.data?.message ||
                error.response.data?.error ||
                error.response.statusText ||
                'Unknown API error';
        } else if (error.message === 'Upload timed out') {
            errorMessage = 'File upload timed out. Please try again.';
        } else if (error.message) {
            errorMessage = error.message;
        }

        alert.error(errorMessage);
        return {
            success: false,
            error: errorMessage
        };
    }
};

export default handleSubmit;